import { Card, Heading, Label } from '@aws-amplify/ui-react';
import {
  MaterialReactTable,
  MRT_ActionMenuItem,
  MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { FC } from 'react';
import DeleteIcon from '@/assets/disable.svg';
import TrashIcon from '@/assets/trash.svg';
import { Button } from '@/components/ui/button';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { useUnitAddressBooks } from '@/hooks/use-address-books';
import { useCurrentUnit } from '@/hooks/use-current-unit';
import { usePolicies } from '@/hooks/use-policies';
import { SectionContainerLayout } from '@/layouts/section-container-layout';
import { api } from '@/redux/api';
import { composeTableOptions } from '@/table';
import { AddressBook } from '@/types/address-book';
import { Unit } from '@/types/unit';
import { AddAddressBookForm } from './add-address-book-form';
import { CreateAddressBookForm } from './create-address-book-form';
import { CreateContactForm } from './create-contact-form';

const columns: MRT_ColumnDef<AddressBook>[] = [
  {
    accessorKey: 'name',
    header: 'Address Book',
    grow: true,
    size: 250,
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function contactsPanelCreator(
  addressBook: AddressBook,
  addressBookPolicyEnabled: boolean,
  unit: Unit,
) {
  const details = [];
  const [deleteAddressBookContact] = api.useDeleteAddressBookContactMutation();

  for (const contact of addressBook.contacts) {
    if (contact.phoneNumber == '22222222') {
      details.push(<Label>DMP Contact name: {contact.name}</Label>);
      details.push(
        <Button
          className="place-self-end"
          disabled={true}
          onClick={() => {
            deleteAddressBookContact({
              organisationId: unit.organisation.id,
              addressBookId: addressBook.addressBookId,
              contactId: contact.contactId ?? '',
              actionType: 'deleteAddressBookContact',
            });
          }}
          variant="primary-warning"
        >
          Delete
          <TrashIcon className="h-6" />
        </Button>,
      );
    } else {
      details.push(
        <Label>
          {contact.name}: {contact.phoneNumber}
        </Label>,
      );
      details.push(
        <Button
          className="place-self-end"
          onClick={() => {
            deleteAddressBookContact({
              organisationId: unit.organisation.id,
              addressBookId: addressBook.addressBookId,
              contactId: contact.contactId ?? '',
              actionType: 'deleteAddressBookContact',
            });
          }}
          variant="primary-warning"
        >
          Delete
          <TrashIcon className="h-6" />
        </Button>,
      );
    }
  }
  return (
    <div className={'flex flex-col gap-2'}>
      <Heading>Contacts</Heading>
      <div className="grid-row grid grid-cols-2 items-center gap-2">
        {details}
      </div>
      {addressBookPolicyEnabled === true && (
        <>
          <Heading>Add Contact</Heading>
          <CreateContactForm
            addressBookId={addressBook.addressBookId}
          ></CreateContactForm>
        </>
      )}
    </div>
  );
}

export const CurrentAddressBooksView: FC = () => {
  const { data: addressBooks, isFetching } = useUnitAddressBooks();
  const { data: unit } = useCurrentUnit();
  const [unassignAddressBook] = api.useUnassignAddressBookMutation();

  const { data: policies } = usePolicies();
  const addressBookPolicyEnabled = policies?.addressBook.editEnabled || false;

  const table = useMaterialReactTable({
    ...composeTableOptions<AddressBook>({
      enableRowActions: true,
    }),
    columns,
    data: addressBooks,
    enableRowActions: true,
    enableExpanding: true,
    renderRowActionMenuItems: ({ row }) => [
      <MRT_ActionMenuItem
        icon={<DeleteIcon />}
        key="delete"
        label="Delete"
        onClick={() => {
          unassignAddressBook({
            unitId: unit!.id,
            organisationId: unit!.organisation.id,
            actionType: 'unassignAddressBook',
            addressBookId: row.original.addressBookId,
          });
        }}
        table={table}
      ></MRT_ActionMenuItem>,
    ],
    renderDetailPanel: ({ row }) =>
      contactsPanelCreator(row.original, addressBookPolicyEnabled, unit!),
    state: {
      isLoading: isFetching,
      ...(isFetching
        ? {
            pagination: {
              pageIndex: 0,
              pageSize: 5,
            },
          }
        : {}),
    },
  });

  return (
    <>
      <SectionContainerLayout horizontal className="border-b-0">
        <SectionHeadingGroup
          className="mb-6"
          subtitle="See what address books are currently applied to this unit"
          title="Current Address Books"
        />
        {/* {!isFetching && addressBooks[0].name} */}
        <MaterialReactTable table={table}></MaterialReactTable>
      </SectionContainerLayout>
      {addressBookPolicyEnabled === true && (
        <>
          <SectionContainerLayout horizontal className="border-b-0">
            <SectionHeadingGroup
              subtitle="Create address books or add an existing one"
              title="Add Address Book"
            />
            <Card className={'flex flex-col gap-4'}>
              <AddAddressBookForm />
              <CreateAddressBookForm />
            </Card>
          </SectionContainerLayout>
        </>
      )}
    </>
  );
};
